import * as actionType from './actionTypes';
import { API_URL } from '../../constants/api';
import { apiBatchRequest, apiRequestNoLoadder } from '../../utils/api_service';
import store from '../appStore';

export const setErrorMessage = (commonlabel) => (dispatch) => {
  dispatch({
    type: actionType.SET_ERROR_PAGE,
    payload: commonlabel
  });
};

export const getNotificationMaster = (query) => dispatch => {
  apiRequestNoLoadder({
    url: API_URL.Dashboard.GetPendingNotifications,
    key: 'pendingNotifications'
  }).then((pendingNotifications) => {
    const sorted = pendingNotifications?.data.sort((a, b) => {
      const aDate = new Date(a.createdDate);
      const bDate = new Date(b.createdDate);
      return bDate.getTime() - aDate.getTime();
    });
    dispatch({
      type: actionType.GET_NOTIFICATION_DATA,
      payload: sorted
    });
  });
};

export const getNotificationMasterData = (query) => {
  apiRequestNoLoadder({
    url: API_URL.Dashboard.GetPendingNotifications,
    key: 'pendingNotifications'
  }).then((pendingNotifications) => {
    const sorted = pendingNotifications?.data.sort((a, b) => {
      const aDate = new Date(a.createdDate);
      const bDate = new Date(b.createdDate);
      return bDate.getTime() - aDate.getTime();
    });
    store.dispatch({
      type: actionType.GET_NOTIFICATION_DATA,
      payload: sorted
    });
  });
};
